export default __webpack_public_path__ + "static/verifyIdPicture-62b8979212b3b3e56c8940939e40ec0e.png";